import React from 'react'
import './Inputfield.css'
import RegionJson from './RegionJson'
import EmployeeJson from './EmployeeJson'
import Twitterfeed from '../Singleselect/Twitter'

const NewSelectfield = ({fieldlabel, placehold, jdarray}) => {
    const handleSelected = (incoming) =>{
      jdarray(incoming)
    }

  return (
    <div className='inputfield-container'>
        <span>{fieldlabel}:</span>

        <Twitterfeed 
          socialjs = {EmployeeJson} 
          selectedSocVal = {handleSelected} 
          placeholder = {placehold}
        />
    </div>
  )
}

export default NewSelectfield